// Fase 22A: presentación del folio operativo en el frontend. El backend ya envía el texto listo
// ("VO-000123") en OtherSaleListItem.folio; aquí solo se centraliza el fallback cuando falta (caso
// límite: una venta creada por el backend anterior durante la ventana de despliegue llega con folio
// null). El frontend NUNCA compone ni envía el folio: es solo lectura/visualización.
export function displayFolio(folio: string | null | undefined): string {
  return folio && folio.trim() !== '' ? folio : '—';
}
